import { CollectedData } from 'src/interfaces/collectedData'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { ONBOARDING_STATUSES_WITH_DELAYED_INFO } from 'src/constants/onboarding/constants'

export function getStepGroupKey(item: CollectedData): string {
  return `${item.collectDataStep.label}-${item.collectDataStep.type}`
}

export function groupContractorSteps(steps: CollectedData[]): [string, CollectedData[]][] {
  const groups = new Map<string, CollectedData[]>()
  for (const item of steps) {
    const key = getStepGroupKey(item)
    const existing = groups.get(key) ?? []

    existing.push(item)
    groups.set(key, existing)
  }

  return Array.from(groups.entries())
}

export interface GroupedStepWithDelayed {
  key: string
  items: CollectedData[]
  delayed: boolean
}

export function getGroupedStepsWithDelayedInfo(
  groupedSteps: [string, CollectedData[]][],
  collectedDataStatus: OnboardingStatus | undefined,
  firstDelayedStepIndex: number,
): GroupedStepWithDelayed[] {
  let stepIndex = 0
  const showDelayedInfo =
    collectedDataStatus != null &&
    ONBOARDING_STATUSES_WITH_DELAYED_INFO.includes(collectedDataStatus)

  return groupedSteps.map(([key, items]) => {
    const isDelayed = showDelayedInfo && firstDelayedStepIndex === stepIndex
    stepIndex += items.length

    return { key, items, delayed: isDelayed }
  })
}
